import { inject, provideAppInitializer } from '@angular/core';
import { AdminSignInErrorService } from './admin-sign-in-error.service';

// Must clear the refused token before the router runs, or its guards redirect on it and loop.
export const ADMIN_SIGN_IN_ERROR_INITIALIZER = provideAppInitializer(() => {
  inject(AdminSignInErrorService).checkForError();
});
